export const UPDATE_LOCATION_PARAMS = 'UPDATE_LOCATION_PARAMS';

export const updateLocationParams = (params: {
  [key: string]: string | null;
}) => {
  return {
    type: UPDATE_LOCATION_PARAMS,
    params,
  };
};
